import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import { alpha } from "@mui/material/styles";
import PropTypes from "prop-types";

const IconButtonWithTooltip = ({
  icon: Icon,
  tooltipTitle,
  onClick,
  color = "primary",
  size = "medium",
  disabled = false,
  sx = {},
  placement = "top",
  arrow = true,
}) => {
  return (
    <Tooltip title={tooltipTitle} placement={placement} arrow={arrow}>
      <IconButton
        color={color}
        onClick={onClick}
        disabled={disabled}
        size={size}
        sx={[
          {
            transition:
              "transform 280ms cubic-bezier(0.34, 1.56, 0.64, 1), background-color 180ms ease, color 180ms ease",
            ...(!disabled && {
              "@media (hover: hover)": {
                "&:hover": {
                  bgcolor: (theme) => alpha(theme.palette[color].main, 0.1),
                  color: `${color}.dark`,
                },
              },
              "&:active": {
                transform: "scale(0.95, 0.92)",
                transition:
                  "transform 90ms ease-out, background-color 180ms ease, color 180ms ease",
              },
            }),
            "@media (prefers-reduced-motion: reduce)": {
              transition: "none",
              "&:active": {
                transform: "none",
                transition: "none",
              },
            },
          },
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
      >
        <Icon />
      </IconButton>
    </Tooltip>
  );
};

IconButtonWithTooltip.propTypes = {
  icon: PropTypes.elementType.isRequired,
  tooltipTitle: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "error",
    "info",
    "success",
    "warning",
  ]),
  size: PropTypes.oneOf(["small", "medium", "large"]),
  disabled: PropTypes.bool,
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.func, PropTypes.array]),
  placement: PropTypes.oneOf(["top", "right", "bottom", "left"]),
  arrow: PropTypes.bool,
};

export default IconButtonWithTooltip;
